const getSuffixKey = () => {
  const userSession = sessionStorage.getItem('_nscorporate_user');
  if (!userSession) return '';

  const userData = JSON.parse(userSession);
  if (!userData) return '';

  return btoa ? `${btoa(userData.login)}_` : `${userData.login}_`;
};

const setItem = (key, value) => {
  if (!value || !key) return;
  const suffixKey = getSuffixKey();
  localStorage.setItem(`${suffixKey}${key}`, JSON.stringify(value));
};

const removeItem = (key) => {
  if (!key) return;
  const suffixKey = getSuffixKey();
  localStorage.removeItem(`${suffixKey}${key}`);
};

const getItem = (key) => {
  if (!key) return;
  const suffixKey = getSuffixKey();
  const value = localStorage.getItem(`${suffixKey}${key}`);
  if (!value) return;
  return JSON.parse(value);
};

export { setItem, getItem, removeItem };
